import axios from 'axios';
import Cookies from 'js-cookie';

export default axios.create({
    baseURL: `${import.meta.env.HAL_API_URL}patientvisit`,
    headers: {
        'X-CSRFToken': Cookies.get('csrftoken'),
    },
    withCredentials: true,
});
